<template>
  <v-dialog v-model="dialog" max-width="600px">
    <v-card class="overflow-x-hidden bugreport">
      <form @submit.prevent="onSubmit">
        <v-card-title class="d-flex flex-column align-start pb-0">
          <span class="headline mb-1" style="width: 100%">
            {{ mess[`widget_bugreport_dialog_title_${form.type}`] }}
          </span>
        </v-card-title>
        <v-card-text class="pb-0">
          <v-container class="pt-0">
            <v-row>
              <v-col cols="12" class="pa-0 pb-2">
                <v-text-field disabled :value="form.email"></v-text-field>
              </v-col>
              <v-col cols="12" class="pa-0 pb-2">
                <v-textarea
                  v-model="form.description"
                  v-validate="'required'"
                  :label="mess[`widget_bugreport_description_${form.type}`]"
                  outlined
                  dense
                  :error-messages="errors.collect('description')"
                  data-vv-name="description"
                ></v-textarea>
              </v-col>
              <v-col cols="12" class="pa-0">
                <file-input
                  v-model="form.files"
                  :label="mess[`widget_common_files_input_label_${form.type}`]"
                ></file-input>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions style="padding: 24px" class="d-flex justify-center">
          <v-btn color="primary" depressed dark type="submit">{{
            mess["widget_common_button_send"]
          }}</v-btn>
        </v-card-actions>
        <v-btn absolute top right text icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import FileInput from "@/components/FileInput";
import Form from "@/mixins/Form";
import { bugreportService } from "@/services/bugreport-service";
import notifications from "@/models/notificationTemplates";

const types = {
  bug: "bug",
  improve: "improve"
};

export default {
  $_veeValidate: {
    validator: "new"
  },
  name: "BugreportDialog",
  components: { FileInput },
  mixins: [Form],
  props: {
    isVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialog: false,
      isSelected: true,
      defaultType: types["bug"],
      form: {
        email: window.initialDataWidgets?.bugreportinitial?.user_email || "",
        description: null,
        type: "bug",
        files: []
      },
      dictionary: {
        custom: {
          description: {
            required: () => this.mess["widget_common_form_required"]
          }
        }
      }
    };
  },
  methods: {
    onSubmit() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          const data = this.createFormData();
          data.append("url", document.location.href);

          bugreportService
            .submit(data)
            .then(() => {
              this.$emit("submit", notifications.success.bugreport);
              this.dialog = false;
              this.clearForm();
            })
            .catch(() => {
              this.$emit("submit", notifications.error.base);
            });
        }
      });
    },
    openDialog(type) {
      this.form.type = types[type] || this.defaultType;
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
    },
    getForm() {
      return this.form;
    },
    setFormProp(prop, value) {
      this.form[prop] = value;
    }
  },
  watch: {
    isVisible(val) {
      this.dialog = val;
    },
    dialog(val) {
      this.$emit("update:is-visible", val);
    }
  },
  mounted() {
    this.$validator.localize("ru", this.dictionary);
  },
  created() {
    const { openDialog, closeDialog, getForm, setFormProp } = this;

    function createWidget() {
      return {
        openDialog,
        closeDialog,
        getForm,
        setFormProp
      };
    }

    window.__WIDGET_BUGREPORT__ = createWidget();
  }
};
</script>

<style lang="scss">
@import "BugreportDialog";
</style>
